import React from "react";
import { Box, Typography } from "@mui/material";
import { BORDA_SUAVE, NAVY, SUPERFICIE, formatarMoeda } from "./utils";

const RodapeTabela = ({ registros, total, selecionados = 0 }) => (
    <Box
        sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2.5,
            py: 1.5,
            backgroundColor: SUPERFICIE,
            borderTop: `1px solid ${BORDA_SUAVE}`
        }}
    >
        <Typography variant="body2" color="text.secondary">
            {registros} registro{registros === 1 ? "" : "s"}
            {selecionados > 0 && ` • ${selecionados} selecionado${selecionados === 1 ? "" : "s"}`}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 700, color: NAVY }}>
            Total: {formatarMoeda(total)}
        </Typography>
    </Box>
);

export default React.memo(RodapeTabela);
